import { createFileRoute } from "@tanstack/react-router";
import { ResearchConsultingServicePage } from "./services_.research-consulting";

export const Route = createFileRoute("/services_/research-consulting-and-media-audit-services")({
  head: () => ({
    meta: [
      {
        title: "Research Consulting & Media Audit Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Comprehensive Media Investment & Efficiency Audits.",
      },
    ],
  }),
  component: ResearchConsultingServicePage,
});
